// Modules
//import React from 'react'
import { useSelector } from 'react-redux';
import type { RootState } from '../../types/store';

// Project
import { Box, Typography } from '@mui/material';
import UITimer from '../../components/ui-timer';

export default function LobbyAdvertise() {
    const lobby = useSelector((state:RootState) => state.page.lobby);
    const translate = useSelector((state:RootState) => state.ui.language.lobby.advertise);
    
    let ad: React.JSX.Element = <></>;
    switch (lobby.advertise.type.toLowerCase()) {
        case "image":
            ad = (
                <Box
                    component="img"
                    src={lobby.advertise.url}
                    alt="Advertisement"
                    sx={{
                        maxHeight: '60dvh',
                        maxWidth: '90vw',
                        objectFit: 'contain',
                        borderRadius: 2,
                        boxShadow: '0 4px 20px rgba(0,0,0,0.3)',
                    }}
                />
            );
            break;
        default:
            ad = (<div>Bad advertise :(</div>);
    }
    
    return (
        <Box
            sx={{
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                overflowY: 'auto',
                scrollbarWidth: 'thin',
                scrollbarColor: '#7dabd0ff rgba(255,255,255,0.1)',
                p: 2,
            }}
        >
            <Box flexShrink={0} width="100%" maxWidth={800} mb={2}>
                <UITimer seconds={lobby.timeleft} reset={false} />
            </Box>
            <Typography variant="h5" align="center" fontWeight={600} mb={2} sx={{ fontSize: 'clamp(1.1rem, 2.5vw, 1.8rem)' }}>
                {translate.advertisement} - {lobby.advertise.title}
            </Typography>
            <Box display="flex" justifyContent="center" alignItems="center" flex={1} minHeight={0}>
                {ad}
            </Box>
        </Box>
    );
}
